import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "@shared-ui/viewport-context";

import { UitkTertiaryButton } from "@egds/react-core/button";
import { UitkIcon, UitkIconSize } from "@egds/react-core/icons";
import { UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";

export function DestinationOverallRating({
  totalReviews,
  avgRating,
  toggleAllDestinationReviews,
  nameForTracking,
}: {
  totalReviews: number;
  avgRating: number;
  toggleAllDestinationReviews: () => void;
  nameForTracking: string;
}) {
  const { formatText } = useLocalization();
  const ratingDescriptor = avgRating >= 4 ? formatText("destinationReviews.topDestination") : "";

  const ButtonTracked = FlexClickTracker(UitkTertiaryButton);

  return (
    <>
      <UitkSpacing margin={{ small: { block: "two" }, large: { block: "four" } }}>
        <UitkLayoutFlexItem className="DestinationReviewAverageRating">
          <div>
            <Viewport>
              <ViewSmall>
                <div className="DestinationReviewAverageRatingText">
                  <UitkText size={500} weight="medium" inline>
                    {avgRating}
                  </UitkText>
                  <UitkText size={500} inline>
                    /5
                  </UitkText>
                  <UitkSpacing padding={{ inlinestart: "two" }}>
                    <UitkText size={400} inline>
                      {ratingDescriptor}
                    </UitkText>
                  </UitkSpacing>
                </div>
              </ViewSmall>
              <ViewLarge>
                <div className="DestinationReviewAverageRatingText">
                  <UitkText size={600} weight="medium" inline>
                    {avgRating}
                  </UitkText>
                  <UitkText size={600} inline>
                    /5
                  </UitkText>
                  <UitkSpacing padding={{ inlinestart: "two" }}>
                    <UitkText size={600} inline>
                      {ratingDescriptor}
                    </UitkText>
                  </UitkSpacing>
                </div>
              </ViewLarge>
            </Viewport>
          </div>
        </UitkLayoutFlexItem>
      </UitkSpacing>
      <UitkSpacing margin={{ small: { block: "two" }, large: { block: "four" } }}>
        <UitkLayoutFlexItem>
          <div>
            <ButtonTracked
              className="DestinationReviewSeeAllRatings"
              onClick={toggleAllDestinationReviews}
              rfrr="Default.OpenReviews"
              moduleName={nameForTracking}
              linkName="RFRR Action Event"
            >
              <>
                <UitkText weight="medium" inline>
                  {formatText("destinationReviews.numberOfReviews", totalReviews, totalReviews.toLocaleString())}
                </UitkText>
                <UitkSpacing padding={{ inlinestart: "two" }}>
                  <UitkIcon name="chevron_right" size={UitkIconSize.SMALL} />
                </UitkSpacing>
              </>
            </ButtonTracked>
          </div>
        </UitkLayoutFlexItem>
      </UitkSpacing>
    </>
  );
}

export default DestinationOverallRating;
